<template>
  <el-container type="flex" class="main_container">
    <base-header>
      <el-button
        @click="addCompany"
        type="primary"
        :loading="resetLoading">
        新增企业订餐用户
      </el-button>
    </base-header>
    <el-main>
      <el-table
        :data="company_list"
        stripe
        style="width: 100%"
        v-loading="tableLoading"
        height="100%">
          <el-table-column
            fixed
            prop="company_name"
            align="center"
            label="企业名称">
          </el-table-column>
          <el-table-column
            prop="phone"
            align="center"
            label="手机号">
          </el-table-column>
          <el-table-column
            prop="contact_name"
            align="center"
            label="联系人姓名">
          </el-table-column>
          <el-table-column
            prop="mansion_name"
            align="center"
            label="所属大厦">
          </el-table-column>
          <el-table-column
            prop="create_time"
            align="center"
            label="添加时间">
          </el-table-column>
          <el-table-column align="center" label="企业余额">
            <template v-slot="scope">
              <div style="display: flex; justify-content: center;" @click="open(scope.row)">
                <p>{{ scope.row.balance }}元</p>
                <el-button type="text" style="margin-left:10px;" size="mini">修改</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="跳转企业用户后台" align="center">
            <template v-slot="scope">
              <p @click="toQiyeManager(scope.row.t_company_id)">跳转链接</p>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template v-slot="scope">
              <el-button type="primary" @click="editCompany(scope.row)">修改</el-button>
            </template>
          </el-table-column>
      </el-table>
    </el-main>
    <el-footer class="footer">
      <el-pagination
        :total="totalCount"
        :page-size="pagesize"
        :current-page="page"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </el-footer>
    <!-- 添加企业用户弹框 -->
    <el-dialog title="企业订餐用户信息" :visible.sync="dialogFormVisible" width="25%">
      <el-form :model="form" label-position="left">
        <el-form-item label="企业名称：" :label-width="formLabelWidth">
          <el-input style="width: 220px;" v-model="form.company_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号：" :label-width="formLabelWidth">
          <el-input style="width: 220px;" v-model="form.phone" :disabled="form.edit" type="tel" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人姓名：" :label-width="formLabelWidth">
          <el-input style="width: 220px;" v-model="form.contact_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="所属大厦：" :label-width="formLabelWidth">
          <el-select v-model="form.t_mansion_info_id" placeholder="请选择所属大厦" style="width:220px;">
            <el-option v-for="item in mansion_list" :key="item.t_mansion_info_id" :label="item.mansion_name" :value="item.t_mansion_info_id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import pageMixin from '../../../mixins/page'
import getTokenMixin from '../../../mixins/getToken'
export default {
  name: 'BusinessUser',
  mixins: [pageMixin, getTokenMixin],
  data () {
    return {
      MansionInfoURL: this.getDomain() + 'bmcompany/get_mansion_info',
      addCompanyURL: this.getDomain() + 'bmcompany/add_company',
      CompanyListURL: this.getDomain() + 'bmcompany/get_company_list',
      modifyBalanceURL: this.getDomain() + 'bmcompany/modify_balance',
      updateCompanyURL: this.getDomain() + 'bmcompany/update_company',
      dialogFormVisible: false,
      formLabelWidth: '100px',
      form: {
        company_name: '',
        phone: '',
        contact_name: '',
        t_mansion_info_id: '',
        edit: false
      },
      labelPosition: 'left',
      mansion_list: [{}],
      company_list: [],
      isAddCompany: false,
      editBalance: ''
    }
  },
  created () {
    this.getMansionInfo()
    this.getList()
  },
  methods: {
    addCompany () {
      this.dialogFormVisible = true
      this.isAddCompany = true
      this.form = {
        company_name: '',
        phone: '',
        contact_name: '',
        t_mansion_info_id: '',
        edit: false
      }
    },
    getMansionInfo () {
      let params = {
      }
      let handle = res => {
        this.mansion_list = res.data.content.mansion_list
      }
      this.__axios(this.MansionInfoURL, params, handle)
    },
    submit () {
      const params = this.form
      let url = this.isAddCompany ? this.addCompanyURL : this.updateCompanyURL
      let handle = res => {
        this.dialogFormVisible = false
        this.form = {
          company_name: '',
          phone: '',
          contact_name: '',
          t_mansion_info_id: '',
          edit: false
        }
        this.getList()
      }
      this.__axios(url, params, handle)
    },
    getList () {
      this.tableLoading = true
      let params = {
        page: this.page,
        pagesize: this.pagesize
      }
      let handle = res => {
        this.totalCount = res.data.content.company_count
        this.company_list = res.data.content.company_list
        this.company_list.forEach(item => {
          item.create_time = this.timeTransform(item.create_time)
          item.balance = item.balance / 100
        })
        this.tableLoading = false
      }
      this.__axios(this.CompanyListURL, params, handle)
    },
    open (row) {
      this.$prompt('请输入价格', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.balance
      }).then(({ value }) => {
        this.editBalance = value
        this.modifyBalance(row)
      }).catch(() => {
      })
    },
    modifyBalance (row) {
      let params = {
        phone: row.phone,
        balance: Number((this.editBalance * 10 * 10).toFixed(2))
      }
      let handle = res => {
        row.balance = this.editBalance
        this.$message.success(res.data.content.desc)
      }
      this.__axios(this.modifyBalanceURL, params, handle)
    },
    editCompany (row) {
      this.isAddCompany = false
      this.dialogFormVisible = true
      this.form = {
        company_name: row.company_name,
        phone: row.phone,
        contact_name: row.contact_name,
        t_mansion_info_id: row.t_mansion_info_id,
        edit: true
      }
    }
  }
}
</script>

<style scoped>
 p {
    cursor: pointer;
    color: #3a8ee6;
  }

</style>
